import { intersection } from "lodash"
import Login from "./pages/auth/Login"
import Illustrations from "./pages/illustrations"
import PromptPlayground from "./pages/playground/prompt"
import VerifyOtpForTwoFa from "./pages/auth/VeriyOtpForTwoFa"
import EnableTwoFa from "./pages/auth/EnableTwoFa"
import routePaths from "./constants/path"
import PatientIssuers from "./pages/PatientIssuers"
import IllustrationMappings from "./pages/IllustrationMappings"
import { userRoles } from "./constants"
import OrderTracking from "./pages/Orders/OrderTracking/OrderTracking"
import OrderComponents from "./pages/OrderComponents/OrderComponents"
import OrderStatistics from "./pages/OrderComponents/OrderStatistics"
import ResultsStatistics from "./pages/OrderComponents/ResultsStatistics"
import ClinicalQA from "./pages/ClinicalQA/ClinicalQA"
import ErrorLogs from "./pages/IllustrationLogs"
import ErrorRelatedReports from "./pages/ErrorRelatedReports"
import AuditLogs from "./pages/AuditLogs"
import SingleAuditLog from "./pages/SingleAuditLog"
import ReroutedReports from "./pages/ReroutedReports"
import MissingPathologies from "./pages/MissingPathologiesStats"
import ErrorCodes from "./pages/ErrorCodes"
import NewLogs from "./pages/NewLogs"
import EducationalVideos from "./pages/EducationalVideos"
import EducationalVideoLogs from "./pages/EducationalVideoLogs"
import VideoStats from "./pages/VideoStats"
import VideoScanAnalytics from "./pages/VideoScanAnalytics"
import VideoScanDashboard from "./pages/VideoScanDashboard"
import RadPeerReports from "./pages/RadPeerReports"
import CustomerSuccess from "./pages/CustomerSuccess"
import CustomerFeedback from "./pages/CustomerFeedback"
import OrderDeliveryInsights from "./pages/OrderDeliveryInsights"
import Settings from "./pages/Settings"

const extractAllRoutes = (routes) => {
  const allRoutes = []

  function traverseRoutes(routeArray) {
    for (const route of routeArray) {
      if (route.path) {
        allRoutes.push(route)
      }
      if (route.children && route.children.length > 0) {
        traverseRoutes(route.children)
      }
    }
  }

  traverseRoutes(routes)
  return allRoutes
}

export const appRoutes = [
  {
    path: routePaths.homepage,
    name: "Logs",
    element: <NewLogs />,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  // {
  //   name: "Logs",
  //   path: null,
  //   otpVerified: true,
  //   isMenuItem: true,
  //   canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  //   children: [
  //     {
  //       name: "Logs",
  //       path: routePaths.logs,
  //       children: [],
  //       element: <Logs />,
  //       isMenuItem: true,
  //       otpVerified: true,
  //       canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  //     },
  //   ],
  // },
  {
    path: routePaths.singleAuditLog,
    name: "Audit Log",
    element: <SingleAuditLog />,
    isMenuItem: false,
    otpVerified: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    path: routePaths.errorReports,
    name: "Illustration Reports",
    element: <ErrorRelatedReports />,
    isMenuItem: false,
    otpVerified: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    name: "Patient Issuers",
    children: [],
    path: routePaths.managePatientIssuers,
    element: <PatientIssuers />,
    isMenuItem: true,
    otpVerified: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },

  {
    path: routePaths.illustrationMappings,
    name: "Pathology Mappings",
    element: <IllustrationMappings />,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    path: routePaths.orderDeliveryInsights,
    name: "Pending Results",
    element: <OrderDeliveryInsights />,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG, userRoles.SUPPORT],
  },
  {
    path: routePaths.customerSuccess,
    name: "Customer Success",
    element: <CustomerSuccess />,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    name: "Educational Videos",
    path: null,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
    children: [
      {
        path: routePaths.videoScanDashboard,
        name: "Scan Dashboard",
        children: [],
        element: <VideoScanDashboard />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        path: routePaths.videoLogs,
        name: "Video Logs",
        children: [],
        element: <EducationalVideoLogs />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        path: routePaths.videoScanAnalytics,
        name: "QR Scan Analytics",
        children: [],
        element: <VideoScanAnalytics />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        path: routePaths.customerFeedback,
        name: "Customer Feedback",
        children: [],
        element: <CustomerFeedback />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        path: routePaths.videoStatsCases,
        name: "Video Source Insights",
        children: [],
        element: <VideoStats />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
    ],
  },
  {
    name: "Reports",
    path: null,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG, userRoles.RADPEER_SUPPORT],
    children: [
      {
        name: "Rerouting",
        children: [],
        path: routePaths.reroutedReports,
        element: <ReroutedReports />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        name: "Missing Pathologies",
        children: [],
        path: routePaths.missingPathologies,
        element: <MissingPathologies />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        name: "RadPeer Reports",
        children: [],
        path: routePaths.radpeerReports,
        element: <RadPeerReports />,
        otpVerified: true,
        canAccess: [
          userRoles.ADMIN,
          userRoles.DEBUG,
          userRoles.RADPEER_SUPPORT,
        ],
      },
      // {
      //   path: routePaths.illustrationImageUsageReport,
      //   name: "Illustration Usage Report",
      //   element: <IllustrationImageUsageReport />,
      //   otpVerified: true,
      //   canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      // },
    ],
  },
  {
    name: "Legacy Logs",
    path: null,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
    children: [
      {
        path: routePaths.illustrations,
        name: "Spine Logs",
        element: <Illustrations />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        path: routePaths.errorLogs,
        name: "Illustration Logs",
        element: <ErrorLogs />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      // {
      //   path: routePaths.illustrationImageUsageReport,
      //   name: "Illustration Usage Report",
      //   element: <IllustrationImageUsageReport />,
      //   otpVerified: true,
      //   canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      // },
    ],
  },
  {
    name: "Debug Tools",
    path: null,
    isMenuItem: true,
    canAccess: [userRoles.DEBUG],
    children: [
      {
        name: "Prompt Playground",
        path: routePaths.playground,
        element: <PromptPlayground />,
        children: [],
        otpVerified: true,
        isMenuItem: true,
        canAccess: [userRoles.DEBUG],
      },
      {
        name: "Dashboard",
        path: routePaths.orderComponents,
        otpVerified: true,
        canAccess: [userRoles.DEBUG],
        element: <OrderComponents />,
      },
      {
        name: "Order Tracking",
        path: routePaths.orderTracking,
        otpVerified: true,
        canAccess: [userRoles.DEBUG],
        element: <OrderTracking />,
      },
      {
        path: routePaths.auditLogs,
        name: "Audit Logs",
        element: <AuditLogs />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        name: "Error Codes",
        children: [],
        path: routePaths.errorCodes,
        element: <ErrorCodes />,
        isMenuItem: true,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        name: "Clinical QA",
        isMenuItem: true,
        canAccess: [userRoles.DEBUG],
        otpVerified: true,
        path: routePaths.clinicalQA,
        element: <ClinicalQA />,
      },
    ],
  },
  {
    name: "Settings",
    path: routePaths.settings,
    element: <Settings />,
    children: [],
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN],
  },
  {
    name: "Order Stats",
    path: routePaths.orders,
    element: <OrderStatistics />,
    children: [],
    otpVerified: true,
    isMenuItem: false,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    name: "Results Stats",
    path: routePaths.results,
    element: <ResultsStatistics />,
    children: [],
    otpVerified: true,
    isMenuItem: false,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
]

export const protectedRoutes = extractAllRoutes(appRoutes)

export const canAccessRoute = (route, roles) =>
  intersection(route?.canAccess, roles).length > 0

// Landing page depends on the role, since not every role can access the homepage
export const getLandingPath = (roles) =>
  protectedRoutes.find((route) => canAccessRoute(route, roles))?.path ??
  routePaths.homepage

export const otpRoutes = [
  {
    path: routePaths.verifyTwoFa,
    element: <VerifyOtpForTwoFa />,
    requirePhase: "verify",
  },
  {
    path: routePaths.enableTwoFa,
    element: <EnableTwoFa />,
    requirePhase: "setup",
  },
]

export const publicRoutes = [
  {
    path: routePaths.login,
    element: <Login />,
  },
  {
    path: routePaths.educationalVideos,
    element: <EducationalVideos />,
  },
]
